export const READER_PANEL_TOOLTIP_CLASSNAME = "reader-progress-background";
